import { ACCESS_KEY } from "../config";
import { useEffect, useState } from "react";
import axios from "axios";

function LiveUsers() {

const [users, setUsers] = useState([]);

useEffect(() => {
  getLiveUsers();
}, []);



const getLiveUsers = async () => {
  try {
    const response = await axios.get(
      "https://admin.butterlive.co.in/management/live-users",
 {
    headers: {
      key: ACCESS_KEY,
    },
  }
    );

    setUsers(response.data.data);
  } catch (error) {
    console.log(error);
  }
};


const liveCut = async (user) => {
  try {
    const response = await axios.post(
      "https://admin.butterlive.co.in/management/live-cut",

      {
        userId: user.userId,
        liveStreamingId: user.liveStreamingId,
      },
 {
    headers: {
      key: ACCESS_KEY,
    },
  }
    );

    alert(response.data.message);

    getLiveUsers();
  } catch (error) {
    console.log(error);
    alert("Live Cut Failed");
  }
};

  return (
    <div>
 <div className="page-header">
  <h1 className="page-title">
    Live Users Management
  </h1>
</div>

      <table
  width="100%"
  cellPadding="12"
  style={{ minWidth: "1400px" }}
>
        <thead>
          <tr>
<th>Sr No</th>
<th>Photo</th>
            <th>Name</th>
            <th>User ID</th>
            <th>Coins</th>
            <th>Diamonds</th>
            <th>Country</th>
            <th>Level</th>
            <th>IsHost</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {users.map((user, index) => (
            <tr key={user.id}>
<td>{index + 1}</td>
              <td>
                <img
  src={user.image}
  alt=""
  width="50"
  height="50"
  style={{
    borderRadius: "50%",
    objectFit: "cover"
  }}
/>
              </td>

              <td>{user.name}</td>
              <td>{user.uniqueId}</td>
              <td>{user.coins}</td>
              <td>{user.diamonds}</td>
              <td>{user.country}</td>
              <td>{user.level}</td>
              <td>
  {user.isHost ? "Yes" : "No"}
</td>

              <td>
                <button onClick={() => liveCut(user)}>
  Live Cut
</button>
              </td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default LiveUsers;
